import Amex from '@spa/shared/svg/amex';
import Klarna from '@spa/shared/svg/klarna';
import Mastercard from '@spa/shared/svg/mastercard';
import Paypal from '@spa/shared/svg/paypal';
import Visa from '@spa/shared/svg/visa';
import ApplePay from '@spa/shared/svg/apple-pay';
import GooglePay from '@spa/shared/svg/google-pay';

export const PAYMENT_METHODS = [
  { name: 'visa', Icon: Visa },
  { name: 'american-express', Icon: Amex },
  { name: 'mastercard', Icon: Mastercard },
  { name: 'paypal', Icon: Paypal },
  { name: 'klarna', Icon: Klarna },
  { name: 'apple-pay', Icon: ApplePay },
  { name: 'google-pay', Icon: GooglePay }
];
